module.exports = __webpack_public_path__ + "public/img/item-e71754d8.png";